<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <h6 class="text-blueGray-700 text-xl font-bold">Logo</h6>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-6">
      <!-- Current logo -->
      <div class="mb-4" v-if="logoUrl">
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">Logo actual</label>
        <img :src="logoUrl" alt="Logo empresa" class="h-20 w-auto object-contain border rounded p-2 bg-white" />
      </div>

      <!-- Upload -->
      <div>
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
          {{ logoUrl ? "Reemplazar logo" : "Subir logo" }}
        </label>
        <input
          type="file"
          accept="image/png,image/jpeg,image/gif,image/webp,image/svg+xml"
          @change="onFileChange"
          class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-bold file:bg-emerald-50 file:text-emerald-700 hover:file:bg-emerald-100"
        />
      </div>

      <!-- Preview -->
      <div class="mt-4" v-if="preview">
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">Vista previa</label>
        <img :src="preview" alt="Preview" class="h-20 w-auto object-contain border rounded p-2 bg-white" />
        <button
          @click="uploadLogo"
          :disabled="uploading"
          class="mt-3 bg-emerald-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          {{ uploading ? "Subiendo..." : "Guardar logo" }}
        </button>
        <button
          @click="cancelPreview"
          class="mt-3 ml-2 bg-blueGray-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaService from "@/services/empresa.service";
import { useToast } from "vue-toastification";

export default {
  props: {
    idempresa: {
      required: true,
    },
    logoVersion: {
      default: 0,
    },
  },

  data() {
    return {
      preview: null,
      selectedBase64: null,
      selectedFormat: null,
      uploading: false,
    };
  },

  computed: {
    logoUrl() {
      if (!this.idempresa || !this.logoVersion) return null;
      return EmpresaService.getLogoUrl(this.idempresa, this.logoVersion);
    },
  },

  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();
      this.selectedFormat = extension === "jpg" ? "jpeg" : extension;

      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result;
        this.preview = dataUrl;
        // Strip the data:image/...;base64, prefix
        this.selectedBase64 = dataUrl.split(",")[1];
      };
      reader.readAsDataURL(file);
    },

    cancelPreview() {
      this.preview = null;
      this.selectedBase64 = null;
      this.selectedFormat = null;
    },

    async uploadLogo() {
      const toast = useToast();
      this.uploading = true;
      try {
        const result = await EmpresaService.uploadLogo(
          this.idempresa,
          this.selectedBase64,
          this.selectedFormat
        );
        toast.success("Logo guardado exitosamente");
        this.$emit("logoUpdated", result.version);
        this.cancelPreview();
      } catch (e) {
        toast.error("No se pudo guardar el logo");
        console.error(e);
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
